var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevnueMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    display: "inline",
    strokeWidth: 0.262629,
    strokeMiterlimit: 4,
    strokeDasharray: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-78.547 2.664v15.14h8.035v2.528h-3.263v1.006H-62.225v-1.006H-65.49v-2.527h8.035V2.665Zm15.365 1.93h3.532v3.58h-.995V6.312l-3.732 3.784-1.676-1.7-3.13 3.37-.342.365-.727-.686.342-.365 3.834-4.13 1.699 1.722 3.031-3.07h-1.836zM-74.525 6.45h.994v.998h1.67v1h-3.34V9.73h3.34v3.288h-1.67v1h-.994v-1h-1.67v-.998h3.332v-1.29h-3.332V7.45h1.67V6.95Zm7.537 5.553h7.025v1H-66.988zm-1.742 2.021H-59.963v.998H-68.73zm-.78 3.78h3.02v2.527h-3.02z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(80.001 -.001)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    paintOrder: "fill markers stroke",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevnueMap);
export default __webpack_public_path__ + "static/media/revnue_map.7a2ee439f50156afbbdf0685b8ef09fd.svg";
export { ForwardRef as ReactComponent };